var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"setting-main-wrapper"},[_c('div',{staticClass:"main-left-menu"},[_c('LeftMenu')],1),_c('Banner'),_c('div',{staticClass:"shop-side p-md-0"},[_c('LeftMenuSide',{attrs:{"openTabSet":_vm.openTabSet}}),_c('EventDetail',{staticClass:"content-wrap-info"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }